import React, { Fragment } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { NavigationPath } from "@/router/navigation-path";
import { useAuthStore } from "@/zustand/auth/store";
import { Maintenance } from "@/components";

export const AuthGuard: React.FC = () => {
  const { getData } = useAuthStore();

  const authData = getData();

  if (!authData?.accessToken) {
    return <Navigate to={NavigationPath.landing} replace />;
  }

  return (
    <Fragment>
      <Outlet />
      <Maintenance />
    </Fragment>
  );
};
